import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import {
  createGranularRequestConfig,
  GranularCatalogConfig,
} from "@granular/fabric-catalog-helpers";
import { OperationResponseV4 } from "../../schemas";

const GET = async (
  operationId: string,
  catalogConfig: GranularCatalogConfig,
  axiosRequestConfig?: AxiosRequestConfig,
): Promise<AxiosResponse<OperationResponseV4>> => {
  const url = `/api/roles-svc/v4/operations/${operationId}`;
  const response = await axios.get(
    url,
    createGranularRequestConfig(catalogConfig, { axiosRequestConfig }),
  );
  return response;
};

export default {
  GET,
};
